import { openAlert } from "../components/Modal/MsgBox";
import { fetchGet } from "./fetch";

export const setUserToken = (user) => document.cookie = `userToken=${encodeURI(JSON.stringify(user))}; path=/`;

export const getUserToken = () => {
  const token = document.cookie.split('; ')
    .find(cookie => cookie.startsWith("userToken"))?.split('=')[1];

  return token ? decodeURI(token) : '';
};

export const deleteUserToken = () => {
  document.cookie = "userToken=; max-age=0; path=/;";
};

export const getTokenPayload = () => {
  const token = getUserToken();

  let payload = {
    id: 0,
    name: '',
    authorities: [],
  };

  try {
    payload = JSON.parse(token);
  } catch (error) {
    console.error("Invalid JSON string:", error);
  }

  return payload;
};

export const submitLogout = () => {
  fetch(`/api-tlo/logout`, {}).then((res) => {
    if(res.status === 200) {
      openAlert(
        "로그아웃 되었습니다.",
        () => window.location.href = `/`
      );
    }
    deleteUserToken();
  });
}

export const checkIsLogin = (setIsLogin = () => {}) => {
    fetch(`/api-tlo/users/myinfo`, {}).then((res) => {
      if(res.status === 200 || res.status === 400 || res.status === 500) {
        return res.json();
      } else {
        // 세션 만료
        setIsLogin(false);
        submitLogout();
      }
    }).then(json => {
      if(json.message === undefined && json.id !== undefined) {
        setUserToken(json);
        setIsLogin(true);
      } else {
        setIsLogin(false);
        submitLogout();
      }
    }).catch(e => {
      openAlert(e.message);
    });
}

export const checkLoginAnd = (setIsLogin = () => {}, afterIsLogined = () => {}, afterIsNotLogined = () => {}) => {
  fetch(`/api-tlo/users/myinfo`, {}).then((res) => {
    if(res.status === 204) {
      setIsLogin(false);
      console.log(res.status)
      afterIsNotLogined();
    } else if(res.status === 200 || res.status === 400) {
      return res.json();
    } else if(res.status === 500) {
      new Error("로그인 정보를 찾을 수 없습니다.");
    } else {
      setIsLogin(false);
    }
  }).then((json) => {
    if(json === undefined) {
      setIsLogin(false);
      afterIsNotLogined();
    } else {
      setUserToken(json);
      setIsLogin(true);
      afterIsLogined();
    }
  }).catch(e => {
      openAlert(e.message);
  });
}
